/* eslint-disable camelcase */
import { GET_DROPDOWN_SUCCESS, GET_DROPDOWN_FAILURE } from '../actions';
import { put, select } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { convertObjectToQueryParams } from 'src/utils/util';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { accountNumberZeroTrimmer } from 'src/utils/util';

const getURLForDropDown = (
    dropDownName,
    value,
    physicianDropdownZGVisibility,
    salesOrg,
    countryISOCode,
    orderType
) => {
    if (
        physicianDropdownZGVisibility === 'VISIBLE' &&
        dropDownName === 'physicianList'
    ) {
        dropDownName = 'physicianZGList';
    }
    let url = `/occ/v2/${localStorage.getItem('baseSiteId')}`;
    switch (dropDownName) {
        case 'territories':
            url += value
                ? `/aardt/territories?isOrderCreation=true&districtCode=${value}`
                : '/aardt/territories?isOrderCreation=true';
            break;
      case 'accounts': {
    const params = convertObjectToQueryParams(value);
    url += `/aardt/accounts?${params}`;
    if (!params.includes('orderType=')) {
        url += `${params ? '&' : ''}orderType=${orderType || 'KE'}`;
    }
    break;
}
        case 'districts':
            url += '/aardt/districts?isOrderCreation=true';
            break;
        case 'caseCoverageEmployees': {
            const case_params = convertObjectToQueryParams(value);
            url += `/order/surgery/casesupport?${case_params}`;
            break;
        }
        case 'procedureList':
            url += '/order/Surgery/procedure';
            break;
        case 'specialStockPartnerDetails':
            const case_params = convertObjectToQueryParams(value);
            url += `/aardt/specialstockpartner?${case_params}`;
            break;
        case 'physicianList': {
            const physicain_parmas = convertObjectToQueryParams(value);
            url += `/order/surgery/physician?${physicain_parmas}`;
            break;
        }
        case 'physicianZGList': {
            const physicain_parmas = convertObjectToQueryParams(value);
            url += `/aardt/accountPhysician?${physicain_parmas}`;
            break;
        }
        case 'templates': {
            const resourceType = 'ORDER_TEMPLATE_A';
            const templateParams = convertObjectToQueryParams({
                ...value,
                resourceType: resourceType,
                templateType: value.orderType,
            });
            url += `/productTemplates/templateslist?${templateParams}`;
            break;
        }
        case 'billToDetails': {
            const caseParams = convertObjectToQueryParams(value);
            url += `/aardt/billtoaccounts?${caseParams}`;
            break;
        }
        default:
            break;
    }
    return url;
};
export default function* getDropDown(action) {
    const value = action.payload.value;
    const { physicianDropdownZGVisibility, salesOrg, countryISOCode } =
        yield select((state) => ({
            physicianDropdownZGVisibility:
                state.loginReducer.physicianDropdownZGVisibility,
            salesOrg: state.loginReducer.salesOrg,
            countryISOCode: state.loginReducer.hybrisUserDetails.countryISOCode,
        }));
    const url = getURLForDropDown(
        action.payload.dropDownName,
        action.payload.value ? action.payload.value : action.payload.value,
        physicianDropdownZGVisibility,
        salesOrg,
        countryISOCode,
        action.payload?.orderType ? action.payload.orderType : action.payload?.value?.orderType ? action.payload?.value?.orderType : 'KE'
    );
    try {
        const result = yield axios.get(url).then((response) => response.data);
        let dropDownResult = result[action.payload.dropDownName];
        if (action.payload.dropDownName === 'caseCoverageEmployees') {
            if (dropDownResult) {
                dropDownResult = dropDownResult
                    .map((item) => {
                        const caseCoverageName = `${
                            item.caseCoverageFirstName
                        } ${
                            item.caseCoverageLastName
                        } ${accountNumberZeroTrimmer(
                            item.caseCoverageCustomerId
                        )}`;
                        item.caseCoverageFormattedName = caseCoverageName;
                        return item;
                    })
                    .filter((element) => element.caseCoverageEmpId != 'Other');
            }
        } else if (action.payload.dropDownName === 'billToDetails') {
            if (dropDownResult) {
                dropDownResult = dropDownResult.map((item) => {
                    const billToDetailsName = `${
                        item.billToName
                    } ${accountNumberZeroTrimmer(item.billToNumber)}`;
                    item.billToFormattedName = billToDetailsName;
                    item.filterValue = ` ${item.billToNumber} ${item.billToName} `;
                    return item;
                });
            }
        }
        if (action.payload.dropDownName === 'specialStockPartnerDetails') {
            if (dropDownResult) {
                dropDownResult = dropDownResult.map((item) => {
                    const sbName = `${item.sbName} ${accountNumberZeroTrimmer(
                        item.sbNumber
                    )}`;
                    item.sbFormattedName = sbName;
                    item.filterValue = ` ${item.sbNumber} ${item.sbName} `;
                    return item;
                });
            }
        } else if (action.payload.dropDownName === 'accounts') {
            if (dropDownResult) {
                dropDownResult = dropDownResult.map((item) => {
                    const accountName = `${
                        item.accountName
                    } ${accountNumberZeroTrimmer(item.accountId)}`;
                    item.accountFormattedName = accountName;
                    item.filterValue = ` ${item.accountId} ${item.accountName} `;
                    return item;
                });
            }
        } else if (action.payload.dropDownName === 'templates') {
            dropDownResult = result.templateList || [];
        } else if (action.payload.dropDownName === 'physicianList') {
            if (dropDownResult) {
                const excludeOthersPhysicianList = dropDownResult.filter(
                    (item) =>
                        item?.physicianId !== 'sst_phy_other' &&
                        item?.physicianFirstName !== 'Other'
                );

                if (excludeOthersPhysicianList?.length > 0) {
                    dropDownResult = excludeOthersPhysicianList.map((item) => {
                        let physicanName = `${item.physicianFirstName} ${item.physicianLastName} ${item.surgeonNumber}`;
                        if (item?.physicianDisplayName) {
                            physicanName = `${
                                item.physicianDisplayName
                            }  ${accountNumberZeroTrimmer(item.physicianId)}`;
                        }
                        item.physicanFormattedName = physicanName;
                        item.filterValue = ` ${item.physicianId} ${item.physicanFormattedName} `;
                        return item;
                    });
                }
            }
        }
        yield put({
            type: GET_DROPDOWN_SUCCESS,
            items: dropDownResult || [],
            name: action.payload.dropDownName,
            statusCode: result.statusCode,
            statusMessage: result.statusMessage,
            loadAll: value?.isLoadAll,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_DROPDOWN_FAILURE,
            name: action.payload.dropDownName,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
